import {
  coreExtensionData,
  createExtension,
  createExtensionInput,
} from '@backstage/frontend-plugin-api';
import {
  BuildVersion,
  EnhancedNavItemBlueprint,
} from '@ipen-portal/plugin-common-react';
import { Navigation } from '@ipen-portal/plugin-navigation-react';
import { z } from 'zod';

import { HeaderComponentsContext } from './HeaderComponentsContext';

/**
 * This extension overrides the default nav extension to add a feature flag to the nav items.
 */
export const NavExtensionOverride = createExtension({
  attachTo: { id: 'app/layout', input: 'nav' },
  configSchema: {
    // TODO if there is a better solution, migrate to it!
    //  see issue: https://github.com/backstage/backstage/issues/31220
    itemsAddons: z
      .record(
        z.string(),
        z.object({
          featureFlag: z.string().optional(),
        }),
      )
      .optional(),
  },
  * factory({ config, inputs }) {
    const items = inputs.items.map(item => {
      const target = item.get(EnhancedNavItemBlueprint.dataRefs.target);
      return {
        featureFlag: config.itemsAddons?.[item.node.spec.id]?.featureFlag,
        id: item.node.spec.id,
        ...target,
      };
    });

    yield coreExtensionData.reactElement(
      <HeaderComponentsContext.Consumer>
        {headerComponents => (
          <Navigation
            items={items}
            mobileHeaderAdditions={headerComponents}
            version={<BuildVersion />}
          />
        )}
      </HeaderComponentsContext.Consumer>,
    );
  },
  inputs: {
    items: createExtensionInput([EnhancedNavItemBlueprint.dataRefs.target]),
  },
  name: 'nav',
  output: [coreExtensionData.reactElement],
});
